import React from "react";
import PropTypes from "prop-types";
import useHover from "../../../hooks/useHover";
import classnames from "classnames";
import { makeStyles, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      margin: theme.spacing(0.5),
      flex: "0 0 auto",
      boxShadow: "0px 1px 5px 0px rgba(0, 0, 0, 0.2)",
      border: "1px solid rgba(255, 255, 255, 0.15)",
      touchAction: (props) => props.isMe && "none",
      backgroundColor: "#323a41",
      backgroundImage: "url('./images/avatar_background.svg')",
      backgroundPosition: "center",
      backgroundSize: "auto",
      backgroundRepeat: "no-repeat",
      borderRadius: 24,
      [theme.breakpoints.down("xs")]: {
        borderRadius: 0,
        margin: theme.spacing(0.2),
      },
      "&.hover": {
        borderRadius: 24,
        boxShadow:
          "0px 1px 3px rgba(0, 0, 0, 0.05) inset, 0px 0px 8px rgba(82, 168, 236, 0.9)",
        [theme.breakpoints.down("xs")]: {
          borderRadius: 0,
        },
      },
      "&.active-speaker": {
        borderRadius: 24,
        borderWidth: 2,
        borderColor: "rgb(12, 211, 205)",
        [theme.breakpoints.down("xs")]: {
          borderRadius: 0,
        },
      },
      "&:not(.active-speaker):not(.screen)": {
        // transition : 'filter 10s',
        // filter     : 'grayscale(0.75)'
      },
      "&.webcam": {
        order: (props) => (props.isMe ? 2 : 4),
      },
      "&.screen": {
        order: (props) => (props.isMe ? 1 : 3),
      },
      "&.mini": {
        borderRadius: 0,
      },
    },
    viewContainer: {
      position: "relative",
      width: "100%",
      height: "100%",
      borderRadius: 24,
      [theme.breakpoints.down("xs")]: {
        borderRadius: 0,
      },
    },
  })
);

const MediaBox = ({
  activeSpeaker = false,
  style,
  hoverable = true,
  isWebcam = true,
  isScreen = false,
  isMe = false,
  mini = false,
  children,
}) => {
  const classes = useStyles({ isMe: isMe });
  const [hoverRef, isHovered] = useHover();
  return (
    <div
      ref={hoverRef}
      className={classnames(
        classes.root,
        isWebcam && "webcam",
        hoverable && isHovered && "hover",
        activeSpeaker && "active-speaker",
        isScreen && "screen",
        mini && "mini"
      )}
      style={style}
    >
      <div className={classes.viewContainer}>{children}</div>
    </div>
  );
};

MediaBox.propTypes = {
  activeSpeaker: PropTypes.bool,
  style: PropTypes.object,
  hoverable: PropTypes.bool,
  isWebcam: PropTypes.bool,
  isScreen: PropTypes.bool,
  isMe: PropTypes.bool,
  children: PropTypes.node,
};

export default MediaBox;
